import * as util from './util';
import CONST from './const';
import logger from './logger';
import Deferred from './lib/Deferred';

let _id = 0;
let wsList = window._WS_UPLOAD_LIST_ || []; // 加个全局，防止多次加载脚步导致连接太多

const websocketTest = location.href.indexOf('__uploadWSTest=1') !== -1;
const SOCKET_URL = `${
  location.protocol === 'https:' ? 'wss:' : 'ws:'
}//${util.getHost()}/ws/upload`;
const SOCKET_COUNT = util.getWebsocketCount; // 创建 websocket 数量

const getId = () => {
  return _id++;
};

class UploadWebScoket {
  constructor(props) {
    this.props = props;

    this._socket = null;
    this._connectDefer = null;
    this._retry = 0;
    this._sendTimer;
    this._closeTimer = 0;
    this._retryDelay = 3000;
    this._reqList = {};
  }

  readyState() {
    return (this._socket && this._socket.readyState) || -1;
  }

  connect(event) {
    // 发生 error 或 close， 延迟一会再重连
    if (Date.now() - this._closeTimer < this._retryDelay) {
      let rejectDefer = new Deferred();
      // 直接 reject 居然是同步的
      setTimeout(() => {
        rejectDefer.reject({
          ret: CONST.REPORT.WEBSOCKET_CLOSE_DELAY,
          msg: 'webpack close delay',
        });
      }, 0);
      return rejectDefer;
    }

    this._connectDefer = this._connectDefer || new Deferred();
    this._connectDefer.startTime = this._connectDefer.startTime || Date.now();

    if (this._socket) {
      if (this.readyState() === 1) {
        // 连接成功，直接 resolve
        this._connectDefer.resolve({ ret: 0, msg: '' });
        return this._connectDefer;
      } else {
        // 还没连接成功，直接 return，等 open resolve
        return this._connectDefer;
      }
    }

    this._socket = new WebSocket(`${this.props.url}${websocketTest ? '?uin=382310210' : ''}`);

    this._connectDefer.wsTimer = setTimeout(() => {
      util.report007(
        'WEBSOCKET_OPEN',
        2,
        CONST.REPORT.CONNECT_ERROR,
        this._connectDefer ? Date.now() - this._connectDefer.startTime : 3000,
      );
    }, 3000);

    this._socket.addEventListener('open', event => {
      util.report007('WEBSOCKET_OPEN', 0, 0, Date.now() - this._connectDefer.startTime);

      clearTimeout(this._connectDefer.wsTimer);
      this._connectDefer.resolve({ ret: 0, msg: '' });
    });

    this._socket.addEventListener('error', event => {
      this._connectDefer &&
        this._connectDefer.reject({
          ret: CONST.REPORT.CONNECT_ERROR,
          msg: `websocket connect error`,
        });
      this.onclose({
        ret: CONST.REPORT.WEBSOCKET_UNKNOW_CLOSE,
        msg: `websocket close`,
      });
    });

    this._socket.addEventListener('message', event => {
      this.onmessage(event);
    });

    this._socket.addEventListener('close', event => {
      // 断线次数上报
      util.report007('WEBSOCKET_CLOSE_TIME', 0, this._retry, 0);

      // 关闭原因统计
      util.report007(
        'WEBSOCKET_CLOSE_REASON',
        0,
        event.code || CONST.REPORT.WEBSOCKET_UNKNOW_CLOSE,
        0,
      );

      this._connectDefer &&
        this._connectDefer.reject({
          ret: CONST.REPORT.WEBSOCKET_UNKNOW_CLOSE,
          msg: `websocket close`,
        });
      this.onclose({
        ret: CONST.REPORT.WEBSOCKET_UNKNOW_CLOSE,
        msg: `websocket close`,
      });
    });

    this._retry++;

    return this._connectDefer;
  }

  // 返回正在请求中的数量
  count() {
    return Object.keys(this._reqList).length;
  }

  onmessage(event = {}) {
    let result = JSON.parse(event.data);
    let id = result.id;

    let resultData = result.data;

    if (this._reqList[id]) {
      clearTimeout(this._reqList[id].wsTimer);
      this._reqList[id].resolve(resultData);

      if (websocketTest) {
        result.performance = result.performance || {};
        result.performance.serverRes = result.performance.serverRes || 0;
        result.performance.clientOnMessage = Date.now() - result.performance.clientReq;
        console.log(
          `websocket url ${this.props.url} id ${id} cost ${result.performance.clientOnMessage}ms`,
        );
      }

      delete this._reqList[id];
    }
  }

  onclose(result) {
    this._connectDefer = null;
    this._socket = null;
    this._closeTimer = Date.now();

    for (let id in this._reqList) {
      clearTimeout(this._reqList[id].wsTimer);
      this._reqList[id].reject(result);

      delete this._reqList[id];
    }
  }

  /**
   *  包装一下数据，同时传 json 和 blob，因为分片数据用 blob 会小一点
   *  主要 node 端解包用，前 10 个为头部信息，主要记录 json 的长度
   *   0-10
   *  header | json | file
   */
  pack(id, data) {
    let header;
    let file = '';
    let json;

    if (
      ['FileUpload', 'FileUploadVoice', 'FileUploadVideo', 'FileUploadTouchuan'].indexOf(
        data.cmd,
      ) !== -1
    ) {
      file = data.info.data;
      delete data.info.data;
    }

    data._clientReqTime = Date.now();

    json = new Blob(
      [
        JSON.stringify({
          id: id,
          data: data,
        }),
      ],
      { type: 'application/json' },
    );

    header = ('0000000000' + json.size).slice(-10);

    return new Blob([header, json, file]);
  }

  send(data = {}) {
    let id = getId();

    this._reqList[id] = new Deferred();

    this.connect()
      .done(() => {
        this._socket.send(this.pack(id, data));
      })
      .fail((error = {}) => {
        logger.log(`websocket connect error ret: ${error.ret}`);
        if (this._reqList[id]) {
          clearTimeout(this._reqList[id].wsTimer);
          this._reqList[id].reject(error);
          delete this._reqList[id];
        }
      });

    return this._reqList[id];
  }
}

export const send = data => {
  if (!util.supportWebSocket()) {
    let rejectDefer = new Deferred();
    setTimeout(() => {
      rejectDefer.reject({
        ret: CONST.REPORT.NOT_SUPPORT_WEBSOCKET,
        msg: 'not support websocket',
      });
    }, 0);
    return rejectDefer;
  }

  init();

  // 每次找请求数最少的来
  let wsIndex = 0;
  let min = 99999;

  wsList.forEach((ws, index) => {
    if (ws.count() < min) {
      wsIndex = index;
      min = ws.count();
    }
  });

  return wsList[wsIndex].send(data);
};

const init = () => {
  let currLen = wsList.length;
  let ws;
  for (let i = 0, len = SOCKET_COUNT - currLen; i < len; i++) {
    ws = new UploadWebScoket({
      url: `${SOCKET_URL}/ws${currLen + i}`,
    });

    wsList.push(ws);
    ws.connect();
  }
};

// 初始化
wsList.push(
  new UploadWebScoket({
    url: `${SOCKET_URL}/ws0`,
  }),
);

if (util.supportWebSocket()) {
  wsList[0].connect();
}

window._WS_UPLOAD_LIST_ = wsList;

export const support = util.supportWebSocket;
